'use strict';
/*exported Router */
/*global Container */
function Router(containerName) {
  this.containerName = containerName;
  this.container = null;

  this.init();
}

Router.prototype = $.extend({}, {
  constructor: 'Router',

  //**************************************************************************

  bridgeFormation: function bridgeFormation(action) {
    var _this = this;

    return _this.path('bridge_formation', { Action: action.replace(':', '__') });
  },

  path: function path(path, params) {
    var _this = this;

    params = params || {};

    var query = '';

    if (_this.container.has(path)) {
      path = _this.container.get(path);
    }

    if (params) {
      for (var par in params) {
        if (par) {
          var parPattern = '%23' + par + '%23';
          if (path.indexOf(parPattern) >= 0) {
            path = path.replace(parPattern, encodeURIComponent(params[par]));
          } else {
            query += query ? '&' : '';
            query += par + '=' + encodeURIComponent(params[par]);
          }
        }
      }
    }

    return path + (path.indexOf('?') < 0 ? '?' : '&') + query;
  },

  add: function add(path, url) {
    var _this = this;

    _this.container.set(path, url);

    return _this;
  },

  //**************************************************************************
  init: function init() {
    var _this = this;

    _this.container = new Container();
    if (_this.containerName) {
      if (_this.containerName in window) {
        var array = window[_this.containerName];
        _this.container.loadFromArray(array);
      }
    }

  }
});
